import { CategoricalBarChartData } from '../types/categorical-bar-chart.js';

export const numericValueData: CategoricalBarChartData[] = [
  { category: 'Banana', value: 10 },
  { category: 'Apple', value: 50 },
  { category: 'Strawberry', value: 30 },
  { category: 'Grapes', value: 40 },
  { category: 'Coconut', value: 80 },
];

export const recordValueData: CategoricalBarChartData[] = [
  { category: 'Banana', value: { stock: 10, box: 100 } },
  { category: 'Apple', value: { stock: 50 } },
  { category: 'Strawberry', value: { stock: 30 } },
];

export const recordNegativeValueData: CategoricalBarChartData[] = [
  { category: 'Banana', value: { stock: -10, box: -100, potato: -200 } },
];

export const recordMixedValueData: CategoricalBarChartData[] = [
  {
    category: 'Banana',
    value: { stock: -10, box: -100, potato: 200, apple: 150 },
  },
];

export const differentUnitsData: CategoricalBarChartData[] = [
  { category: 'Banana', value: 10, unit: 'percent' },
  { category: 'Apple', value: 50 },
  { category: 'Strawberry', value: 30, unit: 'percent' },
  { category: 'Grapes', value: 40 },
];

export const colorOverrideSingle: CategoricalBarChartData[] = [
  { category: 'Banana', value: 10, color: 'red' },
  { category: 'Apple', value: 50, color: 'blue' },
  { category: 'Strawberry', value: 30 },
  { category: 'Grapes', value: 40 },
];

export const colorOverrideMultiple: CategoricalBarChartData[] = [
  { category: 'Banana', value: { kgs: 10, amount: 1 }, color: 'red' },
  { category: 'Apple', value: { kgs: 50, amount: 1 }, color: 'blue' },
  { category: 'Strawberry', value: { kgs: 30, amount: 1 } },
  { category: 'Grapes', value: { kgs: 40, amount: 1 } },
];

export const stringValuesData = [
  { category: 'Unacceptable', value: '5', unit: 'votes' },
  { category: 'Poor', value: '56', unit: 'votes' },
  { category: 'Fair', value: '280', unit: 'votes' },
  { category: 'Good', value: '129', unit: 'votes' },
  { category: 'Excellent', value: '17', unit: 'votes' },
];

export const multipleStringValuesData = [
  {
    category: 'mobile-app',
    value: {
      Unacceptable: '8',
      Poor: '21',
      Fair: '45',
      Good: '212',
      Excellent: '32',
    },
  },
  {
    category: 'marketing-web-app',
    value: {
      Unacceptable: '3',
      Poor: '0',
      Fair: '25',
      Good: '154',
      Excellent: '78',
    },
  },
  {
    category: 'social-media-app',
    value: {
      Unacceptable: '11',
      Poor: '32',
      Fair: '45',
      Good: '212',
      Excellent: '57',
    },
  },
  {
    category: 'ecommerce-web-app',
    value: {
      Unacceptable: '0',
      Poor: '12',
      Fair: '4',
      Good: '26',
      Excellent: '253',
    },
  },
];
